module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Favorites"
  }, [(_vm.animal.id) ? _c('slider', {
    attrs: {
      "items": _vm.items
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485af897"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Favorites.vue
// module id = 834
// module chunks = 1